import Vue from 'vue'
import Router from "vue-router";
import {store} from "@/store";


import Body from '../components/body'
import Auth from '../auth/auth'

/* Auth */
import login from '../auth/login'

import {userMe} from "@/repositories/GeneralDataRepository";
import Dashboard from "../pages/scc/dashboard/Dashboard.vue";
import Sector from "../pages/scc/request/lists/Sector.vue";
import Announcement from "../pages/scc/general/Announcement.vue";
import Request from "../pages/scc/request/Request.vue";
import MyRequests from "../pages/scc/request/lists/MyRequests.vue";
import Favorites from "../pages/scc/request/lists/Favorites.vue";
import ChangeAccount from "../pages/scc/account/ChangeAccount.vue";
import UnderConstruction from "../pages/scc/general/UnderConstruction.vue";
import CompanyProfile from "../pages/scc/company/CompanyProfile.vue";
import CompanyBoard from "../pages/scc/company/CompanyBoard.vue";
import FaqPage from "../pages/scc/general/FaqPage.vue";
import StaticPage from "../pages/scc/general/StaticPage.vue";
import UserProfile from "../pages/scc/account/UserProfile.vue";
import ConversationDetails from "../pages/scc/request/ConversationDetails.vue";
import NewRequest from "../pages/scc/request/NewRequest.vue";
import CompanySearch from "../pages/scc/company/CompanySearch.vue";
import CompanyPage from "../pages/scc/company/CompanyPage.vue";
import RequestsByType from "../pages/scc/request/lists/RequestsByType.vue";
import ASANCallback from "../auth/ASANCallback";
import EditRequest from "../pages/scc/request/EditRequest.vue";
import Search from "../pages/scc/request/Search.vue";
import Purchases from "../pages/scc/request/lists/Purchases.vue";
import Offers from "../pages/scc/request/lists/Offers.vue";
import Sales from "../pages/scc/request/lists/Sales.vue";
import SubscriptionPage from "@/pages/scc/package/SubscriptionPage.vue";
import InvoicesPage from "@/pages/scc/package/InvoicesPage.vue";
import CompanyUserSectors from "@/pages/scc/company/CompanyUserSectors.vue";
import Newsletter from "@/pages/scc/general/newsletter.vue";
import MyRating from "@/pages/scc/account/MyRating.vue";
import AddonPage from "../pages/scc/package/AddonPage.vue";
import VendorManagement from "@/pages/scc/vendorManagement/VendorManagement.vue";
import VendorManagementDashboard from "@/pages/scc/vendorManagement/VendorManagementDashboard.vue";
import CompanyFormEdit from "@/pages/scc/vendorManagement/CompanyFormEdit.vue";
import CompanyFormAdminView from "@/pages/scc/vendorManagement/CompanyFormAdminView.vue";
import CompanyFormPublicView from "@/pages/scc/vendorManagement/CompanyFormPublicView.vue";
import SupplierOutgoingVendorRequests from "@/pages/scc/vendorManagement/supplier/SupplierOutgoingVendorRequests.vue";
import CompanyVendors from "@/pages/scc/vendorManagement/CompanyVendors.vue";
import VendorManagementRequests from "@/pages/scc/vendorManagement/VendorManagementRequests.vue";
import VendorManagementForms from "@/pages/scc/vendorManagement/VendorManagementForms.vue";
import VendorManagementBlacklist from "@/pages/scc/vendorManagement/VendorManagementBlacklist.vue";
import VendorManagementReports from "@/pages/scc/vendorManagement/VendorManagementReports.vue";
import CustomerRequests from "@/pages/scc/vendorManagement/supplier/CustomerRequests.vue";
import Feedback from "@/pages/scc/account/Feedback.vue";
import Advices from "@/pages/scc/general/Advices.vue";
import NewRFQRequest from "@/pages/scc/request/create/NewRFQRequest.vue";
import register from "@/auth/register.vue";
import NewInfoRequest from "@/pages/scc/request/create/NewInfoRequest.vue";
import NewOfferRequest from "@/pages/scc/request/create/NewOfferRequest.vue";
import NewLogisticRequest from "@/pages/scc/request/create/NewLogisticRequest.vue";
import NewTRKRequest from "@/pages/scc/request/create/NewTRKRequest.vue";
import NewTRSRequest from "@/pages/scc/request/create/NewTRSRequest.vue";
import NewAUCRequest from "@/pages/scc/request/create/NewAUCRequest.vue";
import NewREVRequest from "@/pages/scc/request/create/NewREVRequest.vue";
import NewPolRequest from "@/pages/scc/request/create/NewPolRequest.vue";
import passwordChange from "@/auth/password-change.vue";
import PersonalCompanyActivate from "@/pages/scc/company/PersonalCompanyActivate.vue";
import MyProducts from "@/pages/scc/products/MyProducts.vue";
import MyAllProducts from "@/pages/scc/products/MyAllProducts.vue";
import NewProductOrService from "@/pages/scc/products/NewProductOrService.vue";
import Product from "@/pages/scc/products/Product.vue";
import ProductSearch from "@/pages/scc/products/ProductSearch.vue";
import EditProduct from "@/pages/scc/products/EditProduct.vue";

// component

Vue.use(Router)

const routes = [
    {path: '', redirect: {name: 'welcome'}},
    {
        path: '/dashboard',
        component: Body,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: 'welcome',
                name: 'welcome',
                component: Dashboard,

            },
            {
                path: 'change',
                name: 'changeAccount',
                component: ChangeAccount,

            },
            {
                path: 'feedback',
                name: 'feedback',
                component: Feedback,

            },
            {
                path: 'advices',
                name: 'advices',
                component: Advices,

            },
            {
                path: 'sector/:sectorId',
                name: 'sector',
                component: Sector,

            },
            {
                path: 'requests/:type',
                name: 'requestsByType',
                component: RequestsByType,

            },
            {
                path: 'announcement/:id',
                name: 'announcement',
                component: Announcement,

            },
            {
                path: 'newRequest',
                name: 'newRequest',
                component: NewRequest,
            },
            {
                path: 'new/PQ',
                name: 'newPQ',
                component: NewRFQRequest,
                meta: {}
            },
            {
                path: 'new/INFO',
                name: 'newINFO',
                component: NewInfoRequest,
                meta: {}
            },
            {
                path: 'new/OFFER',
                name: 'newOFFER',
                component: NewOfferRequest,
                meta: {}
            },
            {
                path: 'new/LOGISTIC',
                name: 'newLogistic',
                component: NewLogisticRequest,
                meta: {}
            },
            {
                path: 'new/TRK',
                name: 'newTRK',
                component: NewTRKRequest,
                meta: {}
            },
            {
                path: 'new/TRS',
                name: 'newTRS',
                component: NewTRSRequest,
                meta: {}
            },
            {
                path: 'new/AUC',
                name: 'newAUC',
                component: NewAUCRequest,
                meta: {}
            },
            {
                path: 'new/REV',
                name: 'newREV',
                component: NewREVRequest,
                meta: {}
            },

            {
                path: 'new/POL',
                name: 'newPOL',
                component: NewPolRequest,
                meta: {}
            },

            {
                path: 'request/:id',
                name: 'request',
                component: Request,

            },
            {
                path: 'editRequest/:id',
                name: 'editRequest',
                component: EditRequest,
            },
            {
                path: 'myRequests',
                name: 'myRequests',
                component: MyRequests,

            },
            {
                path: 'purchases',
                name: 'purchases',
                component: Purchases,

            },
            {
                path: 'sales',
                name: 'sales',
                component: Sales,

            },
            {
                path: 'offers',
                name: 'offers',
                component: Offers,

            },
            {
                path: 'conversations',
                name: 'conversationList',
                redirect: {
                    path: "conversation/0"
                },

            },
            {
                path: 'conversation/:id',
                name: 'conversation',
                component: ConversationDetails,
                props: (route) => ({ conversationType: route.query.conversation_type })
            },
            {
                path: 'favorites',
                name: 'favorites',
                component: Favorites,

            },
            {
                path: 'user/profile',
                name: 'userProfile',
                component: UserProfile,

            },
            {
                path: 'company/profile',
                name: 'companyProfile',
                component: CompanyProfile,

            },
            {
                path: 'company/board',
                name: 'companyBoard',
                component: CompanyBoard,

            },
            {
                path: 'company/search',
                name: 'companySearch',
                component: CompanySearch,

            },
            {
                path: 'company/personal',
                name: 'companyPersonalCreate',
                component: PersonalCompanyActivate,

            },
            {
                path: 'company/:id',
                name: 'companyPage',
                component: CompanyPage,

            },
            {
                path: 'faq',
                name: 'faq',
                component: FaqPage,

            },
            {
                path: 'search',
                name: 'search',
                component: Search,

            },

            {
                path: 'page/:slug',
                name: 'page',
                component: StaticPage,

            },
            {
                path: 'subscription',
                name: 'subscriptionPage',
                component: SubscriptionPage,

            },
            {
                path: 'invoices',
                name: 'invoicesPage',
                component: InvoicesPage,

            },
            {
                path: 'companyUserSectors',
                name: 'companyUserSectors',
                component: CompanyUserSectors,

            },
            {
                path: 'myRating',
                name: 'myRating',
                component: MyRating,

            },
            {
                path: 'addOn',
                name: 'addOnPage',
                component: AddonPage,

            },
            {
                path: 'outgoingVMRequests',
                name: 'vendorManagementOutgoingRequests',
                component: SupplierOutgoingVendorRequests,

            },
            {
                path: 'customerRequests',
                name: 'vendorManagementCustomerRequests',
                component: CustomerRequests,

            },
            {
                path: 'products',
                name: 'myProductsPage',
                component: MyProducts
            },
            {
                path: 'myProducts',
                name: 'myAllProductsPage',
                component: MyAllProducts
            },
            {
                path: 'newProduct',
                name: 'newProductOrServicePage',
                component: NewProductOrService
            },
            {
                path: 'product/:id',
                name: 'product',
                component: Product,
            },
            {
                path: 'product/edit/:id',
                name: 'editProduct',
                component: EditProduct,
            },
            {
                path: 'products/search',
                name: 'productSearch',
                component: ProductSearch,
            },
            {
                path: 'vendorManagement',
                name: 'vendorManagement',
                component: VendorManagement,
                children: [
                    {
                        path: '',
                        redirect: {name: 'vendorManagementDashboard'}
                    },
                    {
                        path: 'dashboard',
                        name: 'vendorManagementDashboard',
                        component: VendorManagementDashboard,
                        children: []
                    },
                    {
                        path: 'form/edit/:id',
                        name: 'vendorManagementFormEdit',
                        component: CompanyFormEdit,
                        children: []
                    },
                    {
                        path: 'form/manage/:id',
                        name: 'vendorManagementFormManage',
                        component: CompanyFormAdminView,
                        children: []
                    },
                    {
                        path: 'vendors',
                        name: 'vendorManagementVendorList',
                        component: CompanyVendors,
                        children: []
                    },
                    {
                        path: 'forms',
                        name: 'vendorManagementFormList',
                        component: VendorManagementForms,
                        children: []
                    },
                    {
                        path: 'requests',
                        name: 'vendorManagementRequestList',
                        component: VendorManagementRequests,
                        children: []
                    },
                    {
                        path: 'blacklist',
                        name: 'vendorManagementBlackList',
                        component: VendorManagementBlacklist,
                        children: []
                    },
                    {
                        path: 'reports',
                        name: 'vendorManagementReports',
                        component: VendorManagementReports,
                        children: []
                    },
                ]
            },
        ]
    },


    {
        path: '/form/:id',
        name: 'vendorFormView',
        component: CompanyFormPublicView,

    },

    {
        path: '/newsletter/:email',
        name: 'newsLetter',
        component: Newsletter,

    },

    {
        path: '/asan/:transaction',
        name: 'asanCallback',
        component: ASANCallback,

    },
    {
        path: '/auth',
        component: Auth,
        children: [
            {
                path: 'login',
                name: 'Login',
                component: login,
            },
            // {
            //     path: 'register',
            //     name: 'register',
            //     component: register,
            // },
            {
                path: 'changePassword',
                name: 'changePassword',
                component: passwordChange,
            }
        ]
    }
    ,

    {
        path: "/:catchAll(.*)", component: UnderConstruction
    }

];

const router = new Router({
    routes,
    base: '/',
    mode: 'history',
    linkActiveClass: "active",
    scrollBehavior() {
        return {x: 0, y: 0}
    }
});

router.beforeEach((to, from, next) => {
    let token = localStorage.getItem("token");
    if (token) {

        userMe(token).then(({
                                code,
                                message,
                                type,
                                user,
                                notificationCount,
                                messageCount,
                                company,
                                profileType,
                                position,
                                package: userPackage,
                                packageStatus,
                                limits,
                                sectorAdded,
                                hasAdmin, isAdmin, companyUserStatus
                            }) => {

            if (code === 200) {

                store.dispatch('auth/setToken', token);
                store.dispatch('auth/setUser', user);
                store.dispatch('auth/setNotificationCount', notificationCount);
                store.dispatch('auth/setMessageCount', messageCount);
                store.dispatch('auth/setCompany', company);
                store.dispatch('auth/setProfile', profileType);
                store.dispatch('auth/setPosition', position);
                store.dispatch('auth/setSessionType', type);
                store.dispatch('auth/setUserPackage', userPackage);
                store.dispatch('auth/setUserPackageStatus', packageStatus);
                store.dispatch('auth/setPackageLimits', limits);
                store.dispatch('auth/setSectorAdded', !!sectorAdded);
                store.dispatch('auth/setHasAdmin', !!hasAdmin);
                store.dispatch('auth/setIsAdmin', !!isAdmin);
                store.dispatch('auth/setCompanyUserStatus', companyUserStatus);


                if (type === 'personal') {
                    if ([
                            '/dashboard/change',
                            '/dashboard/user/profile',
                            '/dashboard/faq',
                            '/dashboard/advices',
                            '/dashboard/company/search',
                            '/dashboard/company/personal',
                            '/auth/changePassword',
                        ].indexOf(to.path) < 0
                        && !to.path.startsWith("/dashboard/page/")
                        && !to.path.startsWith("/dashboard/company/")
                        && !to.path.startsWith('/newsletter/')) {
                        return next("/dashboard/change");
                    }
                }

                return next();

            } else if (code === 201 || code === 424) {
                store.dispatch('auth/setToken', token);

                if (to.path !== '/auth/changePassword') {
                    return next("/auth/changePassword");
                } else {
                    return next();
                }
            } else if (code === 401) {
                localStorage.removeItem("token");
                return next("/auth/login?next=" + encodeURIComponent(to.path));
            } else {
                alert(`Error ${code}:  ${message}`);
                window.location.reload();
            }

        })
    } else {
        const path = ['/auth/login', '/auth/register'];
        if (to.path.startsWith("/form/") || to.path.startsWith("/asan/") || to.path.startsWith('/newsletter/') || path.includes(to.path) || to.path === "/callback") {
            return next();
        } else {
            next('/auth/login?next=' + encodeURIComponent(to.path))
        }
    }
});

export default router
